/**
 * useToast Hook
 *
 * Hook to access toast notifications from any component.
 */

import { useContext } from 'react';
import { ToastContext, type ToastContextType } from '../contexts/toastContextDef';

export const useToast = (): ToastContextType => {
  const context = useContext(ToastContext);
  if (context === undefined) {
    throw new Error('useToast must be used within ToastProvider');
  }
  return context;
};
